import React from 'react';
import styled from 'styled-components';

export const TextButton: React.FC<{ children: React.ReactNode; onClick: () => void }> = ({ children, onClick }) => {
  return <StyledTextButton onClick={onClick}>{children}</StyledTextButton>;
};

const StyledTextButton = styled('div')({
  opacity: 0.5,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
  '&:active': { backgroundColor: 'rgba(0, 0, 0, 0.3)' },
  borderRadius: 4,
  padding: '4px 8px',
});
